import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// Abstract polymorphic resource for the `conditionable` role. Concrete types
// (company, tas-program-template, ...) declare `conditions` with
// `as: 'conditionable'`; this resource exists so the polymorphic
// `condition.conditionable` target type resolves through the schema service
// instead of recursing into the legacy ModelSchemaProvider / ShimModelClass
// (RangeError: Maximum call stack size exceeded). Mirrors owner/messageable.
const ConditionableSchema = withDefaults({
  type: 'conditionable',
  fields: [
    {
      kind: 'hasMany',
      name: 'conditions',
      type: 'condition',
      options: {
        async: false,
        inverse: 'conditionable',
        as: 'conditionable',
      },
    },
  ],
});

export default ConditionableSchema;
